import { render } from "./EditSign.vue?vue&type=template&id=c3d8f1cc&scoped=true"
import script from "./EditSign.vue?vue&type=script&lang=js"
export * from "./EditSign.vue?vue&type=script&lang=js"

import "./EditSign.vue?vue&type=style&index=0&id=c3d8f1cc&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-c3d8f1cc"

export default script